export default __webpack_public_path__ + "static/media/AddUser.34421536.svg";